<div class="venue__profile">
  <div class="settings d-flex flex-row">
    <!-- <mat-icon style="font-size: 20px; padding-top: 12px;">more_vert</mat-icon> -->
  </div>
  <div class="venue__wrapper d-flex flex-row">
    <div class="d-flex flex-row">
      <img src="./assets/images/icons/venue-logo-placeholder-01.svg" alt="profile-picture">
      <div class="company-info">
        <h5 style="font-weight: 300;" class="title">{{ company.companyName }}</h5>
        <div class="company__profile__role">
          <!-- <p>{{ companyTypesString }}</p>  -->
          <a class="user__link" href="{{ company.websiteUrl }}" target="_blank">{{ company.websiteUrl }}</a>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row">
      <!-- <div>Administrators Component</div>
      <div>Hosts Component</div> -->
    </div>
  </div>
</div>

<div class="venues__container">
  <div class="settings d-flex flex-row">
    <!-- <mat-icon style="font-size: 20px; padding-top: 12px;">more_vert</mat-icon> -->
  </div>
  <div class="venues__header d-flex flex-row">
    <h5 class="title-bold">{{ 'VENUES.VENUES' | translate }}</h5>
    <div>
      <div>
        <!-- <div>
          Search Component
        </div> -->
      </div>
    </div>
  </div>
  <div class="venues__additional d-flex flex-row">
    <div class="d-flex flex-row">
      <mat-icon>location_on</mat-icon><span>{{ 'VENUES.VENUES' | translate | uppercase }}</span>
    </div>
  </div>
  <div *ngIf="venuesList?.length !=0 else noVenues" class="venues_list custom-scroll-bar"
    style="padding-right: 40px; height: 380px;overflow: auto;"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollUpDistance]="1000"
    (scrolled)="loadMoreVenues()"
    [scrollWindow]="false"
    #dataContainer>
    <app-venue-item *ngFor="let venue of venuesList" [venue]="venue" [businessTypes]="company.businessTypesCompanies" [companyCountryCode]="countryCode">
    </app-venue-item>
  </div>
  <ng-template #noVenues>
    <div class="container-fluid mt-4">
      <div class="row">
        <div class="col-12 no-items">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <img src="./assets/images/icons/reservations_empty@3x.png" alt="no-reservations" class="img-responsive">
            <p class="mt-2">{{'VENUES.NO_VENUES' | translate}}</p>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<p-toast position="center" key="company-check" (onClose)="onRejectToast()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center pb-4">
        <i class="pi pi-info-circle" style="font-size: 3rem"></i>
        <h5>{{ 'VENUES.CHECK_COMPANY' | translate }}</h5>
      </div>
      <div class="p-fluid d-flex align-items-center justify-content-center">
        <div class="col-10">
          <button type="button" pButton (click)="onConfirmToast()" label="{{ 'VENUES.GO_TO_COMPANY_PROFILE' | translate }}"
            class="info"></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
